import React, { Component } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import PhoneNumber from '../../components/PhoneNumber/PhoneNumber';

import './Help.scss';

class Help extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false
    };

    this.openHelp = this.openHelp.bind(this);
    this.toggle = this.toggle.bind(this);
  }
  openHelp() {
    this.setState({modalOpen: true});
  }
  toggle() {
    this.setState({modalOpen: !this.state.modalOpen});
  }
  render() {
    return (
      <div>
        <div className="help-button" onClick={this.openHelp}></div>
        <Modal isOpen={this.state.modalOpen} toggle={this.toggle} className="slide-in-right" modalClassName="help">
          <div className="close" onClick={this.toggle}></div>
          <ModalBody>
            <h1>Need help?</h1>
            <div className="phone"><PhoneNumber value="604-877-4999" /> or <PhoneNumber value="1-800-611-8472" /> (toll-free)</div>
            <a href="https://support.vancity.com/" target="_blank" rel="noopener noreferrer" className="faq">Credit Card Support</a>
            <a href="https://www.vancity.com" target="_blank" rel="noopener noreferrer" className="vancity">Back to vancity.com</a>
          </ModalBody>
        </Modal>
      </div>
    );
  }

}

export default Help;


// WEBPACK FOOTER //
// ./src/containers/Help/Help.js